import { Center, Text, Box } from '@chakra-ui/react';
import { FC } from 'react';
import { FontSize } from 'presentation/theme/fontSizes';

interface Props {
  date: string;
}

const ChatDateSeparator: FC<Props> = ({ date }) => {
  return (
    <Center py="20px" px="20px">
      <Box
        px="12px"
        py="6px"
        borderRadius="12px"
        backgroundColor="gray.100"
      >
        <Text
          fontSize={FontSize.sm}
          color="gray.600"
          fontWeight={500}
        >
          {date}
        </Text>
      </Box>
    </Center>
  );
};

export default ChatDateSeparator;
